import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaEye, FaBullseye } from "react-icons/fa";

const VisionMission = () => {
    return (
        <section className="section vision-mission-section">
            <Container>

                <div className="section-title fade-up">
                    <h2>Vision & Mission</h2>
                    <p>
                        Our vision defines where we are heading, and our mission
                        guides how we work every day.
                    </p>
                </div>

                <Row>
                    {/* VISION */}
                    <Col lg={6} className="mb-4 fade-up">
                        <div className="vm-card vision">
                            <div className="vm-icon">
                                <FaEye />
                            </div>
                            <h3>Our Vision</h3>
                            <p>
                                To shape a sustainable agricultural future where productivity
                                and environmental balance grow together. We envision farming
                                systems that protect soil health, conserve natural resources,
                                and ensure long-term prosperity for Indian farmers.
                            </p>
                        </div>
                    </Col>

                    {/* MISSION */}
                    <Col lg={6} className="mb-4 fade-up">
                        <div className="vm-card mission">
                            <div className="vm-icon">
                                <FaBullseye />
                            </div>
                            <h3>Our Mission</h3>
                            <p>
                                To develop safe, effective, and eco-conscious agricultural
                                solutions that improve crop performance, reduce cultivation
                                costs, and build lasting trust with farming communities
                                through consistent quality and innovation.
                            </p>
                        </div>
                    </Col>
                </Row>

            </Container>
        </section>
    );
};

export default VisionMission;
